// @generated by TypeGen from LogbookApi/Stripe - DO NOT EDIT

import type { IStripeCheckoutCompleteResponse, IStripeCheckoutRequest, IStripeCheckoutResponse } from "../LogbookServer/Stripe"
import type { ISuccessResponse } from "../LogbookServer/SuccessResponse"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface StripeEndpoints {
  "POST /api/account/checkout": {
    params: {};
    query: {};
    request: IStripeCheckoutRequest;
    response: IStripeCheckoutResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "POST /api/account/checkout/complete/:sessionId": {
    params: { sessionId: string };
    query: {};
    request: never;
    response: IStripeCheckoutCompleteResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "PUT /api/account/plan": {
    params: {};
    query: {};
    request: never;
    response: ISuccessResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
}

export const stripeEndpoints = {
  "POST /api/account/checkout": { targets: ["server"], permission: { session: true } },
  "POST /api/account/checkout/complete/:sessionId": { targets: ["server"], permission: { session: true } },
  "PUT /api/account/plan": { targets: ["server"], permission: { session: true } },
} as const;

export class Stripe {
  constructor(private client: ApiClient) {}

  account = {
    checkout: (a: ApiArgs<StripeEndpoints, "POST /api/account/checkout">) => ({
      call: (): Promise<IStripeCheckoutResponse> => {
        assertTarget(this.client, "POST /api/account/checkout", stripeEndpoints["POST /api/account/checkout"].targets);
        return this.client.call<IStripeCheckoutResponse>("POST /api/account/checkout", a);
      },
      url: (): string => this.client.url("POST /api/account/checkout", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    checkoutComplete: (a: ApiArgs<StripeEndpoints, "POST /api/account/checkout/complete/:sessionId">) => ({
      call: (): Promise<IStripeCheckoutCompleteResponse> => {
        assertTarget(this.client, "POST /api/account/checkout/complete/:sessionId", stripeEndpoints["POST /api/account/checkout/complete/:sessionId"].targets);
        return this.client.call<IStripeCheckoutCompleteResponse>("POST /api/account/checkout/complete/:sessionId", a);
      },
      url: (): string => this.client.url("POST /api/account/checkout/complete/:sessionId", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    updatePlan: (a: ApiArgs<StripeEndpoints, "PUT /api/account/plan">) => ({
      call: (): Promise<ISuccessResponse> => {
        assertTarget(this.client, "PUT /api/account/plan", stripeEndpoints["PUT /api/account/plan"].targets);
        return this.client.call<ISuccessResponse>("PUT /api/account/plan", a);
      },
      url: (): string => this.client.url("PUT /api/account/plan", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
  };
}
